import insurancePickerSelector from '@zocdoc/components/src/InsurancePicker/data/insurancePickerSelector';

import { getLocationsCarouselState } from './selectors';

export default function mapStateToProps(state, ownProps) {
    const carouselState = getLocationsCarouselState(state) || {};
    const insurancePickerState = insurancePickerSelector(state) || {};

    const carrierId = insurancePickerState.carrier || ownProps.carrierId;
    const planId = insurancePickerState.plan || ownProps.planId;

    const insuranceIsSelected = !!(
        carrierId && parseInt(carrierId, 10) > 0
        && planId && parseInt(planId, 10) > 0
        && ownProps.providerId
    );

    const locationId = (
        carouselState.locationId
        || ownProps.locationId
        || (ownProps.locations && ownProps.locations[0])
    );

    return {
        ...carouselState,
        locationId,
        carrierId,
        planId,
        insuranceIsSelected,
    };
}
